import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

export const acceptTerms = makeSubmitData<{ uid: string }>("acceptTerms");
